<template>
  <div>
      <v-layout row wrap class="overflow p20">
        <v-flex xs12 md12 class='total-sales'>
          <h1>Total Sales - ${{totalSales.toFixed(2)}}</h1>
        </v-flex>
        <v-flex xs12 md6>
          <h2>Online Orders - ${{onlineOrderTotal.toFixed(2)}}</h2> <!-- <v-btn @click="showUserWise = !showUserWise, moreless = (showUserWise ? 'Less' : 'More')">{{moreless}}</v-btn> -->
          <!-- <v-flex v-for="order in onlineOrders" v-bind:key="order._id">
            {{order.customerID.firstName}} {{order.customerID.lastName}} - ${{order.subTotal}}
          </v-flex> -->
        </v-flex>
        <v-flex xs12 md6>
          <h2>Manual Orders - ${{manualOrderTotal.toFixed(2)}}</h2> <v-btn @click="showUserWise = !showUserWise, moreless = (showUserWise ? 'Less' : 'More')">{{moreless}}</v-btn>
          <div v-if="showUserWise">
            <v-flex v-for="(order, user) in this.userwiseSales" v-bind:key="user">
              <h3>{{user}} - ${{order.toFixed(2)}}</h3>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    <!-- <pre>{{orders}}</pre> -->
  </div>
</template>

<script>
export default {
  props: {
    orders: Array
  },
  data: () => ({
    onlineOrders: [],
    manualOrders: [],
    userwiseSales: {},
    manualOrderTotal: 0,
    onlineOrderTotal: 0,
    totalSales: 0,
    showUserWise: false,
    moreless: 'More'
  }),
  mounted () {
    this.onlineOrders = this.orders.filter(function (order) {
      return !order.createdBy && !order.updatedBy
    })
    this.manualOrders = this.orders.filter(function (order) {
      return order.createdBy || order.updatedBy
    })

    for (let index = 0; index < this.manualOrders.length; index++) {
      const order = this.manualOrders[index]
      let salesPerson = ''
      if (order.updatedBy) {
        salesPerson = order.updatedBy.firstName
      } else {
        salesPerson = order.createdBy.firstName
      }

      let orderTotal = order.subTotal
      console.log(orderTotal)
      if (order.shipping != null) {
        orderTotal += order.shipping
      }
      if (order.insurance != null) {
        orderTotal += order.insurance
      }
      if (order.install != null) {
        orderTotal += order.install
      }
      if (order.measure != null) {
        orderTotal += order.measure
      }
      if (order.discount != null) {
        orderTotal -= order.discount
      }
      console.log(orderTotal)
      // this.userwiseSales.push({salesPerson: order.subTotal})
      if (this.userwiseSales[salesPerson]) {
        this.userwiseSales[salesPerson] += orderTotal
      } else {
        this.userwiseSales[salesPerson] = orderTotal
      }
      this.manualOrderTotal += orderTotal
    }
    for (let index = 0; index < this.onlineOrders.length; index++) {
      const order = this.onlineOrders[index]
      let orderTotal = order.subTotal
      if (order.shipping != null) {
        orderTotal += order.shipping
      }
      if (order.insurance != null) {
        orderTotal += order.insurance
      }
      if (order.install != null) {
        orderTotal += order.install
      }
      if (order.measure != null) {
        orderTotal += order.measure
      }
      if (order.discount != null) {
        orderTotal -= order.discount
      }
      this.onlineOrderTotal += orderTotal
    }

    this.totalSales = this.onlineOrderTotal + this.manualOrderTotal
    // console.log(this.userwiseSales)
  }
}
</script>

<style>
.overflow {
  overflow: auto;
  max-height: 412px;
}
.p20 {
  padding: 20px;
}
.total-sales {
  text-align: center;
}
@media screen and (max-width: 661px) {
  .total-sales {
    text-align: left;
  }
  .total-sales h1{
    font-size: 26px;
  }
  .v--modal-overlay .v--modal-box {
    max-width: 100% !important;
    left: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AgendaModal.vue